import { useState, useEffect } from "react";

const navLinks = [
  { label: "Wins", href: "#wins" },
  { label: "Experience", href: "#experience" },
  { label: "Skills", href: "#skills" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState("");

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
      const sections = ["wins", "experience", "skills", "contact"];
      let current = "";
      for (const id of sections) {
        const el = document.getElementById(id);
        if (el && window.scrollY >= el.offsetTop - 120) current = id;
      }
      setActiveSection(current);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (e: React.MouseEvent, href: string) => {
    e.preventDefault();
    const id = href.replace("#", "");
    const el = document.getElementById(id);
    if (el) {
      const navbarHeight = 80;
      const top = el.getBoundingClientRect().top + window.scrollY - navbarHeight;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <nav
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-500"
      style={{
        height: "64px",
        backgroundColor: scrolled
          ? "rgba(20,15,10,0.96)"
          : "rgba(20,15,10,0.0)",
        backdropFilter: scrolled ? "blur(16px)" : "none",
        WebkitBackdropFilter: scrolled ? "blur(16px)" : "none",
        borderBottom: scrolled ? "1px solid rgba(255,255,255,0.06)" : "none",
      }}
    >
      <div className="w-full px-8 h-full flex items-center justify-between">
        {/* Logo */}
        <a
          href="#"
          onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: "smooth" }); }}
          className="font-lora font-medium text-[17px] tracking-tight cursor-pointer whitespace-nowrap transition-colors duration-200"
          style={{ color: scrolled ? "#FAF8F4" : "#FAF8F4" }}
        >
          Josue Tello
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-9">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={(e) => handleNavClick(e, link.href)}
              className="font-dm text-[12px] uppercase tracking-[0.12em] transition-colors duration-200 cursor-pointer whitespace-nowrap"
              style={{
                color: activeSection === link.href.replace("#", "")
                  ? "#C17D3C"
                  : "rgba(250,248,244,0.55)",
              }}
              onMouseEnter={(e) => {
                if (activeSection !== link.href.replace("#", "")) {
                  (e.currentTarget as HTMLButtonElement).style.color = "#FAF8F4";
                }
              }}
              onMouseLeave={(e) => {
                if (activeSection !== link.href.replace("#", "")) {
                  (e.currentTarget as HTMLButtonElement).style.color = "rgba(250,248,244,0.55)";
                }
              }}
            >
              {link.label}
            </button>
          ))}
        </div>

        {/* Resume */}
        <a
          href="https://storage.readdy-site.link/project_files/661f58d1-4775-43ab-846c-b8afe4ff99b3/260837e4-7be0-4bd2-a51f-b0576434f42d_Josue_Tello_Resume_2026_Updated.pdf?v=6800c1e98ecd4a24fffe3c6c63ba4d5c"
          download
          className="flex items-center gap-2 font-dm font-medium text-[12px] uppercase tracking-[0.08em] rounded-full px-5 py-2 transition-all duration-200 hover:-translate-y-px whitespace-nowrap cursor-pointer"
          style={{
            color: "#FAF8F4",
            border: "1px solid rgba(255,255,255,0.2)",
            backgroundColor: "rgba(255,255,255,0.06)",
          }}
          onMouseEnter={(e) => {
            (e.currentTarget as HTMLAnchorElement).style.backgroundColor = "rgba(255,255,255,0.12)";
            (e.currentTarget as HTMLAnchorElement).style.borderColor = "rgba(255,255,255,0.35)";
          }}
          onMouseLeave={(e) => {
            (e.currentTarget as HTMLAnchorElement).style.backgroundColor = "rgba(255,255,255,0.06)";
            (e.currentTarget as HTMLAnchorElement).style.borderColor = "rgba(255,255,255,0.2)";
          }}
        >
          <i className="ri-download-line text-[11px]" />
          Resume
        </a>
      </div>
    </nav>
  );
}
